<template>
  <div class="terms-conditions-wrapper">
    <div class="inner-wrapper"><h3 v-if="showTerms"> GBE Calculator Terms And Conditions</h3>
      <div v-if="showTerms" class="terms-content">
        <h4>Introduction to the GBE Calculator</h4>
        <p>The GBE Calculator (also referred to as “this website”) is provided by Lane Clark & Peacock LLP (“LCP”) on behalf of itself and its collaborator, Analytics FC Limited.</p>

        <h4>Using the GBE Calculator</h4>
        <p>
          Your use of the GBE Calculator is subject to these terms and conditions.  
          Please read these and, if you do not agree to them, you must not use the GBE Calculator.
        </p>
        <p>
          We may amend these terms and conditions from time to time, and our right to do so is not subject to the consent of any other person.  
          Please check them periodically so that you can be informed of any changes.
        </p>
        <p>These terms and conditions were last amended on 17 December 2021.</p>

        <h4>Liability and reliance on information</h4>
        <p>Neither we nor AFC guarantees that this website, or any content on it, will be free from errors or omissions.</p>
        <p>
            In particular, but without limitation to the foregoing, the calculations produced by this website are based on rules agreed by the English Football Association and the Home Office for players to play in England.  
            There will be edge cases and different interpretations.  
            The GBE Calculator outputs are estimates and should be used as a guide to assess the likelihood of a player meeting the criteria, rather than a definitive assessment.  
            The GBE criteria are regularly reviewed by the English Football Association and the Home Office; we cannot guarantee that any changes to the criteria will be allowed for within our calculations immediately.  
            There variations to the GBE criteria for players to play in Scotland, and details can be found on the Scottish Football Association’s website.
        </p>
        <p>Neither we nor AFC accepts any liability for any actions or decisions taken using information on this website.</p>
        <p>To the extent permitted by law, each of LCP and AFC excludes any and all liability for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, 
          or otherwise, even if foreseeable, arising under or in connection with use of, or inability to use, this website or use of or reliance on any content on this website.</p>

        <h4>Information about us</h4>
        <p>
          This website is owned and operated by LCP, a limited liability partnership registered in England and Wales with registered number OC301436 and VAT number GB258363873.  
          LCP is a registered trademark in the UK (Regd. TM No 2315442) and in the EU (Regd. TM No 002935583).  
          All partners are members of LCP.  A list of members' names is available for inspection at 95 Wigmore Street, London W1U1DQ, the firm's principal place of business and registered office.
        </p>
        <p>Lane Clark & Peacock LLP is authorised and regulated by the Financial Conduct Authority and is licensed by the Institute and Faculty of Actuaries for a range of investment business activities.</p>
        <p>Locations in London, Winchester, Ireland, and - operating under licence - the Netherlands.</p>
        <p>© Lane Clark & Peacock LLP 2021</p>
        <p>https://www.lcp.uk.com/emails-important-information contains important information about this communication from LCP, including limitations as to its use.</p>
        <p>LCP is providing this website on behalf of itself and AFC.  AFC is a limited liability company registered in England and Wales with registered number 10185818 and registered office at 35 Locks Hill, Frome, Somerset, BA11 1NA.</p>

        <h4>Access to the GBE Calculator</h4>
        <p>We may update, modify, restrict access to or close this website.  Neither we nor AFC guarantees uninterrupted use of this website or accepts liability for any access delays or interruptions.</p>

        <h4>Definitions</h4>
        <ul>
            <li>
                <p>References to “we”, “us” or “our” are to LCP.</p>
            </li>
            <li>
                <p>References to “you” or “your” are to a user of this website.</p>
            </li>
        </ul>
        <p></p>     

        <h4>Intellectual Property Rights</h4>        
        <p>We are the owner or the licensee of all Intellectual Property Rights in this website and the Content.</p>
        <p>For these purposes:</p>
        <ul>
            <li>
                <p>“Content” means any text, software, database, format, graphic, program code, calculation, formula, model, chart and written work and all other materials developed by, or on behalf of, us and/or AFC which form part of this website; and</p>
            </li>
            <li>
                <p>“Intellectual Property Rights” means:</p>
                <ul>
                  <li>
                      <p>copyright, patents, database rights and rights in trademarks, designs, know-how and confidential information (whether registered or not);</p>
                  </li>
                  <li>
                      <p>applications for registration and the right to apply for registration for any of these rights; and</p>
                  </li>
                  <li>
                      <p>all other intellectual property rights and equivalent or similar forms of protection existing anywhere in the world.</p>
                  </li>
              </ul>
            </li>
        </ul>
        <p></p>    

        <h4>Online privacy</h4>        
        <p>The GBE Calculator Privacy Policy for Authorised Users sets out the basis on which we and AFC will use your personal data in connection with your use of this website.</p>
        <p>In particular, please note that we use information that we collect from this website to send you marketing emails in connection with football analytics and football consultancy services provided by us and/or AFC.</p>

        <h4>Viruses and security</h4>        
        <p>
          Neither we nor AFC guarantees that this website will be free from bugs or viruses.  
          You must use your own virus protection software.  Neither we nor AFC accepts liability for any damage or loss caused by:
        </p>
        <ul>
            <li>
                <p>any virus, malicious code or software, defect or malfunction in connection with use of this website; or</p>
            </li>
            <li>
                <p>any breach of security or unauthorised use of this website arising from hacking or otherwise.</p>
            </li>
        </ul>
        <p></p>        
        <p>You must not misuse this website by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful.</p>
        <p></p>

        <h4>Third party links</h4>
        <p>
          With the exception of TransferLab, where this website contains links to other websites and resources provided by third parties, these links are provided for your information only.  
          We do not endorse any of these websites or accept responsibility for their contents.
        </p>

        <h4>No conditions, warranties or representations</h4>
        <p>To the extent permitted by law, each of LCP and AFC excludes all conditions, warranties and representations in respect of this website and its content (whether express or implied).</p>

        <h4>Other matters</h4>
        <p>Nothing in these terms and conditions excludes or limits LCP or AFC’s liability for fraud or reckless disregard of professional obligations or for death or personal injury arising from our or AFC’s negligence or that of our respective partners, consultants or employees.</p>
        <p>If any of these terms and conditions is held by any judicial or other competent authority to be void, voidable, illegal or otherwise unenforceable, the remaining terms and conditions shall remain in full force and effect.</p>
        <p>Any temporary or permanent waiver on our part of any of the terms and conditions shall not affect our right subsequently to enforce all the terms and conditions.</p>
        <p>
          Save as expressly stated otherwise, none of these terms and conditions is intended to be enforceable pursuant to the Contracts (Rights of Third Parties) Act 1999.  
          Accordingly, no third party, save for AFC, shall have any right to enforce or rely on any of these terms and conditions.
        </p>

        <h4>Governing law</h4>
        <p>These terms and conditions shall be governed by and construed in accordance with English law, and we and you each submit to the exclusive jurisdiction of the English Courts.</p>

      </div>
      
      <h3 v-if="showUserPolicy">Privacy Policy for Users</h3>
      <div v-if="showUserPolicy" class="terms-content">
        <h4>About us</h4>
        <p>This privacy policy is provided on behalf of Lane Clark & Peacock LLP (“LCP”) of 95 Wigmore Street, London, W1U 1DU, registered number OC301436.</p>
        <p>
          LCP is registered with the Information Commissioner’s Office (“ICO”).  
          Our registration number is Z6661882.  
          For the purposes of Data Protection Law, your personal data is processed by us in our capacity data controller for our customers.
          Analytics FC Limited (our collaborator, as further described below) is also a data controller; you can find their privacy notice <a href="https://analyticsfc.co.uk/privacy-policy/" target="_blank">here</a>.
        </p>

        <h4>Scope of this policy</h4>
        <p>
          This privacy policy applies to https://gbe.lcp.uk.com.   
          Save in the case of TransferLab, where links from this website are provided to non-LCP websites, LCP is not responsible for those websites. 
          In the case of TransferLab, that website is the outcome of a collaboration between LCP and Analytics FC Ltd.  Access to TransferLab is subject to separate documentation.
        </p>
        
        <h4>Why do we collect information?</h4>
        <p>
          The reason we collect information about you is to provide you with access to this website and for marketing purposes.  
          Any information you provide will be used only by LCP, and will not be disclosed to any other party or for any other reason (other than as set out in this privacy policy) without your prior consent.
        </p>

        <h4>What information do we gather?</h4>
        <p>We collect your name, email address and organisation.</p>
        
        <h4>How do we use information that we collect from this website?</h4>
        <p>
          Once a specified number of searches has been exceeded, this website can only be accessed by users who have confirmed their acceptance of each of the “tick box” statements presented to them (“authorised users”).  
          LCP must retain a record of authorised users so that rights of access can be restricted to those individuals.
        </p>
        <p>
          This website is provided by LCP on behalf of itself and its collaborator, Analytics FC Limited (company number 10185818, of 35 Locks Hill, Frome, Somerset, BA11 1NA) (the “Collaborator”).  
          LCP will share your information with the Collaborator.
        </p>
        <p>
          We use information that we collect from this website to send you marketing emails in connection with football analytics and football consultancy services provided by the Collaborator and / or LCP.
        </p>

        <h4>Access</h4>
        <p>
          Access to this website is only for authorised users (as defined above).  
          If you have been given access by mistake or suspect that an unauthorised person has used your credentials to register, you must inform us promptly at support@analyticsfc.co.uk.
        </p>

        <h4>Transfer outside of the EEA and Profiling</h4>
        <p>
          We do not use your personal data to make automated decisions about you (including profiling).  
          The Collaborator may transfer your data to another country or international organisation in such circumstances as it considers reasonably necessary for the operation of its business.
        </p>

        <h4>Access to your information and correction</h4>
        <p>
          You have a right to request access to and/or correction to your personal information.  
          If you believe the data we hold on you is incorrect, or you wish to see the information we hold on you, please contact our Data Protection Officer (details below).  
        </p>

        <h4>Security</h4>
        <p>
          Although we maintain appropriate technological and organisational security measures to protect the security of your data against loss, misuse, unauthorised access, disclosure or alteration, the security of the transmission of information via the internet cannot always be guaranteed. 
          You acknowledge this in your use of our website.
        </p>

        <h4>Data retention periods</h4>
        <p>We will retain your personal data for so long as the purpose you have provided it for still exists unless a longer retention period is required or permitted by law.</p>

        <h4>Complaints</h4>
        <p>
          We aim to meet the highest standards when collecting and using your personal information.  However, if you believe we are not meeting these standards and wish to make a complaint, please contact our Data Protection Officer (details below).
          If you are not satisfied with our response you have the right to complain to the Information Commissioner’s Office: https://ico.org.uk/.
        </p>

        <h4>Changes to our privacy policy</h4>
        <p>
          We reserve the right, at our own exclusive discretion, to change, amend, add or remove any part of this privacy notice, at any time. 
          In order to facilitate the review of any such changes, the policy will contain an indication of the date on which the policy was updated.
          We keep our privacy policy under regular review and place any updates on our website.
        </p>
        
        <h4>Cookies</h4>
        <p>
          We only use strictly necessary cookies on this website. 
          These are cookies that are required for the operation of this website. 
          They include cookies that are used to track whether you have reached the maximum number of searches and if so, whether you have provided your details.
        </p>
        <p>
          Your browser will allow you to restrict, block or remove any cookies set by this website. 
          Details of this functionality will vary by browser but can usually be found in the browser help section. 
          The website www.aboutcookies.org contains more details about cookies and options for dealing with them.
        </p>
        
        <h4>How to contact us?</h4>
        <p>If you would like further information about our privacy policy or how to request your personal information you can email us at data.protection@lcp.uk.com or write to:</p>
        <p>The Data Protection Officer</p>
        <p>95 Wigmore Street</p>
        <p>London</p>
        <p>WU1 1DU</p>

      </div>
      <h3 v-if="showPlayerPolicy">Privacy Policy for Players</h3>
      <div v-if="showPlayerPolicy" class="terms-content">
        <h4>About us</h4>
        <p>This privacy policy is provided on behalf of Lane Clark & Peacock LLP (“LCP”) of 95 Wigmore Street, London, W1U 1DU, registered number OC301436.</p>
        <p>
          LCP is registered with the Information Commissioner’s Office (“ICO”).  Our registration number is Z6661882. 
          For the purposes of Data Protection Law, your personal data is processed by us in our capacity data controller for our customers.
        </p>
        <p>Analytics FC Limited (our collaborator, as further described below) is also a data controller; you can find their privacy notice <a href="https://analyticsfc.co.uk/privacy-policy/" target="_blank">here</a></p>

        <h4>Personal data that we may collect about you</h4>
        <p>We may collect and process personal data our business partners provide to us in connection with our provision of the GBE Calculator tool.</p>
        <p>
          Users of the website have the ability to see estimated Governing Body Endorsement (GBE) points for you, as calculated based on the rules agreed by the FA and Home Office for players to play in England.  
          Further information displayed in the site includes your name, date of birth, current club, current league and your position.
        </p>     

        <h4>Why do we collect information?</h4>
        <p>We process personal data for certain legitimate business purposes, which include some or all of the following:</p>
        <ul>
            <li>
                <p>To provide the GBE Calculator to our clients and other users.</p>
            </li>
            <li>
                <p>For any other purpose required or permitted by law.</p>
            </li>
        </ul>
        <p></p>
        <p>
          We process your personal data for these purposes because it is in both your and our users' interest to do so, and it enhances the services that we provide.  
          The GBE Calculator tool helps users identify whether you are likely to be eligible to play in England, making it easier for users to determine if you are suitable to play for potential future employers in England. 
          We do not process your personal data where to do so would prejudice your fundamental rights and freedoms.
        </p>

        <h4>Retention of your personal data</h4>
        <p>We will retain your personal data for so long as the purpose it was collected for still exists unless a longer retention period is required or permitted by law.</p>
        
        <h4>Your rights in respect of your personal data</h4>
        <p>You have the right to:</p>
        <ul>
            <li>
                <p>a copy of your personal data that we hold;</p>
            </li>
            <li>
                <p>have your data corrected if it is inaccurate or incomplete;</p>
            </li>
            <li>
                <p>have your data deleted or removed if it is no longer necessary for the purpose for which it was obtained;</p>
            </li>
            <li>
                <p>request that the way in which we use your data is restricted to certain uses which you may specify;</p>
            </li>
            <li>
                <p>object to us claiming that we have a legitimate interest in processing your data; and</p>
            </li>
            <li>
                <p>request that we provide your personal data that we hold to you, so that you may reuse your data for your own purposes.</p>
            </li>
        </ul>  
        <p></p>
        <p>
          If you wish to exercise any of these rights, please contact us using the contact details listed at the bottom of this privacy policy. 
          We will aim to respond to any request received from you within one month of receipt.
        </p>

        <h4>Transfer outside of the EEA and Profiling</h4>
        <p>We may transfer your data to another country or international organisation in such other circumstances as we consider reasonably necessary for the operation of our business, provided that we ensure that any such transfer complies with Chapter 5 of the GDPR (or any equivalent requirement in Data Protection Law).</p>           
        
        <h4>Automated decision making</h4>
        <p>There is no automated decision-making as data subjects are not subject to decisions made exclusively on the basis of the automated data processing, including profiling, and which produces legal effects concerning them or which significantly affects them in a similar way.</p>           
        
        <h4>How to contact us?</h4>
        <p>If you would like further information about our privacy policy or how to request your personal information you can email us at data.protection@lcp.uk.com or write to:</p>
        <p>The Data Protection Officer</p>
        <p>95 Wigmore Street</p>
        <p>London</p>
        <p>WU1 1DU</p>
        
      </div>
      <button class="btn" @click="closeTerms">Close</button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class TermsAndConditionsWrapper extends Vue {
 
  get showTerms () {
    return this.$store.state.showTerms;
  }
  get showUserPolicy () {
    return this.$store.state.showUserPolicy;
  }
  get showPlayerPolicy () {
    return this.$store.state.showPlayerPolicy;
  }

  public closeTerms () {
    this.$store.commit('updateShowTerms', false)
    this.$store.commit('updateShowPlayerPolicy', false)
    this.$store.commit('updateShowUserPolicy', false)
  }

}
</script>

<style lang="scss" scoped>
.terms-conditions-wrapper {
  position: fixed;
  z-index: 5;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .inner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem;
    width: 60%;
    border-radius: 1rem;
    color: black;
    box-shadow: 0px 1px 20px -5px rgba(68, 68, 68, 0.75);
    background-color: white;
    h3 {
      text-align: center;
    }
    @include mix.responsive('xl') {
      width: 80%;
    }

    @include mix.responsive('md') {
      width: 90%;
    }

    @include mix.responsive('xs') {
      width: 90%;
    }
    .terms-content {
      color: black;
      max-height: 50rem;
      overflow-y: auto;
      margin: 2rem ;
      padding-right: 2rem;
      button {
        margin-top: 2rem;

      }
      p {
        &:not(:last-of-type) {
          margin-bottom: 1rem;
        }
      }
      &::-webkit-scrollbar {
        width: 0.5rem;
      }
      &::-webkit-scrollbar-track {
        border-radius: 1rem;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background: #cccccc;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 1rem;
        box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.5);
        background: #131313;
      }
    }
  }
}
</style>
